import { section } from "@/neon";
import { qs, qsa, toggle, listen } from "@fluorescent/dom";
import { animateArticle } from "@/lib/animation";

section("article", {
  onLoad() {
    this.socialButtons = qsa("[data-social-share]", this.container);

    this.socialButtonsClick = listen(this.socialButtons, "click", e => {
      toggle(e.target, "active");
      const sub = qs(".product__share-icons", e.target);

      sub.setAttribute("aria-hidden", !e.target.classList.contains("active"));
    });
    this.animateArticle = animateArticle(this.container);
  },
  onUnload() {
    this.socialButtonsClick();
    this.animateArticle?.destroy();
  },
});
